(($, Drupal) => {
    Drupal.behaviors.containerSwitcher = {
        attach: function attach() {
            let dropperCreated = false;

            const updateLine = (label, px = 2) => {
              const line = $('.categories__line');

              line.css("left", label.position().left);
              line.css("top", label.innerHeight() + label.position().top - px);
              line.css("width", label.innerWidth());
            }

            const changeOrder = () => {
              const container = $('.container-switcher__labels');
              const checkedInput = $('.categories__input:checked')[0];

              if (checkedInput) {
                const label = $(`label[for=${checkedInput.id}]`);
                container.prepend(label);

                updateLine(label);
              }
            }


            const initDropdown = (container, labels) => {
                if(labels.length > 0) {
                    const firstHeight = $(labels[0]).innerHeight();
                    let fullHeight = 0;
                    $(labels).each(function(index, item) {
                        fullHeight += $(item).innerHeight() + 2;
                    })

                    container.css("overflow", "hidden");
                    container.css("height", firstHeight);

                    if(!dropperCreated) {
                        const dropper = $("<div>", {
                            class: "container-switcher__dropper"
                        });
                        let click = false;
                        dropper.on("click", function() {
                            console.log(fullHeight);
                            click = !click;
                            if(click) {
                                dropper.addClass("clicked");
                                container.css("height", fullHeight);

                                const checkedInput = $('.categories__input:checked')[0];
                                const label = $(`label[for=${checkedInput.id}]`);
                                updateLine(label, 0);
                            }
                            else {
                                dropper.removeClass("clicked");
                                container.css("height", firstHeight);
                                changeOrder();
                            }
                        })
                        container.append(dropper);
                        dropperCreated = true;
                    }

                }
            }

            const destroyDropdown = (container, labels) => {
                container.css("height", "auto");
                container.find(".container-switcher__dropper").remove();
                dropperCreated = false;
            }

            const setDropdown = (container, labels) => {
                if(window.innerWidth < 426)
                    initDropdown(container, labels);
                else destroyDropdown(container, labels);
            }
            $(".container-switcher__labels").once("container-switcher__labels").each(function() {
                const container = $(this);
                const labels = container.find("label");
                setDropdown(container, labels);
                if($($(this).find(".active")).length === 0) {
                    $(this).children().eq(1).addClass("active");
                }
                window.addEventListener("resize", function() {
                    setDropdown(container, labels);
                })

            });

        }
    };

})(jQuery, Drupal);
